import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import AVIcon from '../components/icons/AllVoicedIcons';

export const MOBILE_PORTRAIT_MEDIA_QUERY =
  '(max-width: 640px) and (orientation: portrait)';

function matchesMobilePortrait() {
  return typeof window !== 'undefined' &&
    typeof window.matchMedia === 'function' &&
    window.matchMedia(MOBILE_PORTRAIT_MEDIA_QUERY).matches;
}

export default function MobileOrientationGate({ children }) {
  const { t } = useTranslation();
  const [isMobilePortrait, setIsMobilePortrait] = useState(
    matchesMobilePortrait
  );

  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return undefined;

    const mediaQuery = window.matchMedia(MOBILE_PORTRAIT_MEDIA_QUERY);
    const handleChange = (event) => setIsMobilePortrait(event.matches);

    setIsMobilePortrait(mediaQuery.matches);
    mediaQuery.addEventListener('change', handleChange);

    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  if (!isMobilePortrait) return children;

  return (
    <main className="auth-page" aria-labelledby="mobile-orientation-title">
      <section className="auth-card mobile-orientation-card">
        <AVIcon
          aria-hidden="true"
          className="mobile-orientation-card__icon"
          icon="screenRotation"
          size={64}
        />
        <h1 id="mobile-orientation-title">
          {t('mobile_orientation_title', 'Turn your device sideways')}
        </h1>
        <p>
          {t(
            'mobile_orientation_body',
            'All-Voiced currently works best in landscape on smaller screens. Rotate your device to continue.'
          )}
        </p>
      </section>
    </main>
  );
}
